import {faArrowUpRightFromSquare} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {NavGroupProps, NavItemDataProps} from '@minimal/components/nav-section';
import {appLinks} from '@workspaces/bdese/links';
import {getLinkByEnv} from '@workspaces/link';
import {WorkspaceList, workspacesBasePath} from '@workspaces/workspaces';

const basePath = workspacesBasePath[WorkspaceList.BDESE];
export const externalLink: NavItemDataProps = {
  title: 'menu.external.go-to-app',
  path: getLinkByEnv(appLinks),
  icon: <FontAwesomeIcon icon={faArrowUpRightFromSquare} />,
};

export const menu: NavGroupProps[] = [
  {
    items: [
      externalLink,
      {
        title: 'pages.bdese.labels.thematics',
        path: `${basePath}/thematics`,
        children: [
          {
            title: 'pages.bdese.labels.subthematics',
            path: `${basePath}/subthematics`,
          },
        ],
      },
      {
        title: 'pages.bdese.labels.checklists',
        path: `${basePath}/checklists`,
      },
    ],
  },
];
